import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setOpenModalRevisorBloqueio } from "../../../../store/actions/termos";
import ModalBloqueioPlano from "../../../../components/ModalBloqueioPlano";
import { ModalLink } from "./styles";

const ModalRevisorBloqueio = forwardRef((props, ref) => {
  const termos = useSelector((state) => state.termos);
  const dispatch = useDispatch();

  return (
    termos.openModalRevisorBloqueio && (
      <ModalBloqueioPlano
        onClose={() => dispatch(setOpenModalRevisorBloqueio(false))}
        title="O seu plano não contempla o acesso ao módulo selecionado."
        buttonText="Ok"
      >
        Mas você pode alterá-lo agora mesmo. Ligue para (32) 3212-4324 ou, se preferir, envie a sua mensagem{' '}
        <ModalLink href="http://www.e-auditoria.com.br/contato" target="_blank">
          através do site.
        </ModalLink>
      </ModalBloqueioPlano>
    )
);
});

export default ModalRevisorBloqueio;